import React from 'react';
import { Job } from '../../types/job';
import { QuoteJob } from '../../types/quote';
import { getJobListingTypeLabel } from '../../utils/jobUtils';
import { TFunction } from 'i18next';

interface JobListingTypeProps {
  job: Job | QuoteJob;
  t: TFunction;
  className?: string;
}

const JobListingType: React.FC<JobListingTypeProps> = ({ job, t, className = '' }) => {
  const jobListingTypeLabel = getJobListingTypeLabel(job, t);

  if (!jobListingTypeLabel) {
    return null;
  }

  const isUrgent = 'listing_type' in job && job.listing_type?.code === 'urgent';
  const bgColor = isUrgent ? 'bg-[#FF564A]' : 'bg-[#39C463]';

  return (
    <span
      className={`text-white px-2 py-1 rounded-full font-semibold w-max ${bgColor} ${className}`}
    >
      {jobListingTypeLabel}
    </span>
  );
};

export default JobListingType;
